import React, { useRef } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { getKindMenuItems, navigateToPlanWizard } from '../constants/planWizardTypes';
import '../Styles/pages/product.scss';

export const usePlanCreateNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (groupId, planGroup, wizardType) => {
    navigateToPlanWizard(navigate, groupId, {
      planGroup,
      wizardType,
      returnTo: `${location.pathname}${location.search}`,
    });
  };
};

const PlanCreateKindMenu = ({
  planGroup,
  disabled = false,
  buttonClassName = 'active-action-button',
  buttonId = 'action-button',
  tooltip,
  icon = 'pi pi-plus-circle',
  renderTrigger,
}) => {
  const overlayRef = useRef(null);
  const { t } = useTranslation('common');
  const navigateToWizard = usePlanCreateNavigation();
  const items = getKindMenuItems(t);

  const handleSelect = (wizardType) => {
    overlayRef.current?.hide();
    navigateToWizard(planGroup?.id, planGroup, wizardType);
  };

  const toggleMenu = (event) => {
    event.stopPropagation();
    overlayRef.current?.toggle(event);
    event.currentTarget?.blur?.();
  };

  const handleOverlayShow = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  };

  return (
    <span className="plan-create-kind-menu-trigger">
      {renderTrigger ? (
        renderTrigger({ toggleMenu, disabled })
      ) : (
        <Button
          icon={icon}
          disabled={disabled}
          className={`p-button ${buttonClassName}`}
          id={buttonId}
          tooltip={tooltip}
          tooltipOptions={{
            position: 'bottom',
            showDelay: 400,
          }}
          onClick={toggleMenu}
        />
      )}
      <OverlayPanel
        ref={overlayRef}
        appendTo={document.body}
        dismissable
        onShow={handleOverlayShow}
        className="plan-create-kind-overlay-panel"
      >
        <div className="plan-create-kind-overlay">
          {items.map((item) => (
            <button
              key={item.wizardType}
              type="button"
              className="plan-create-kind-menu-item"
              onClick={() => handleSelect(item.wizardType)}
            >
              <span className="plan-create-kind-title">{item.label}</span>
              <span className="plan-create-kind-description">{item.description}</span>
            </button>
          ))}
        </div>
      </OverlayPanel>
    </span>
  );
};

export default PlanCreateKindMenu;
